import { useQuery } from "@tanstack/react-query";
import { api, endpoints } from "api/api";
import { EmailRecipientApi } from "api/types/EmailRecipient";
import { QUERIES_KEYS } from "queries";

export const useCourseRecipients = (courseId: number | null) => {
  const { isFetching, isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_RECIPIENTS(courseId),
    queryFn: () => api.get<EmailRecipientApi[]>(endpoints.COURSES.GET_RECIPIENTS(courseId!)),
    enabled: courseId !== null && courseId > 0,
  });

  return {
    isFetching,
    isLoading,
    recipients: data?.data ?? [],
    refetch
  };
};

export const useCourseGroupRecipients = (courseGroupId: number | null) => {
  const { isFetching, isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUP_RECIPIENTS(courseGroupId),
    queryFn: () => api.get<EmailRecipientApi[]>(endpoints.COURSEGROUPS.GET_RECIPIENTS(courseGroupId!)),
    enabled: courseGroupId !== null && courseGroupId > 0,
  });

  return {
    isFetching,
    isLoading,
    recipients: data?.data ?? [],
    refetch
  };
};